<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 24 24"
  >
    <g id="icon_list_etc" transform="translate(1100 2134)">
      <path
        id="패스_4050"
        data-name="패스 4050"
        fill-opacity="0"
        d="M0,0H24V24H0Z"
        transform="translate(-1100 -2134)"
      />
      <path
        id="assistant_FILL1_wght400_GRAD0_opsz24"
        fill="#087ef7"
        d="M12,23,9,20H5a2,2,0,0,1-2-2V4a1.928,1.928,0,0,1,.587-1.413A1.928,1.928,0,0,1,5,2H19a1.928,1.928,0,0,1,1.413.587A1.928,1.928,0,0,1,21,4V18a2,2,0,0,1-2,2H15Z"
        transform="translate(-1100 -2134)"
      />
      <path
        id="패스_4044"
        data-name="패스 4044"
        fill="#ffc304"
        d="M19.825,10.65l1.508-3.317L24.65,5.825,21.333,4.317,19.825,1,18.317,4.317,15,5.825l3.317,1.508Z"
        transform="translate(-1107.825 -2128.825)"
      />
    </g>
  </svg>
</template>
<script>
export default {
  props: {
    width: {
      type: Number,
      default: 24,
    },
    height: {
      type: Number,
      default: 24,
    },
  },
};
</script>
